import { createDebugger } from '../utils/debug.js';

const debug = createDebugger('ProductForm', true);

class ProductForm extends HTMLElement {
    constructor() {
        super();
        if (this.hasChildNodes()) this.init();
    }

    init() {
        this.form = this.querySelector('.js-product-form');
        if (this.form) {
            const idInput = this.form.querySelector('[name="id"]');
            if (idInput) {
                idInput.disabled = false;
            }
            this.cartDrawer = document.querySelector('cart-drawer');
            this.submitBtn = this.querySelector('[name="add"]');

            this.addEventListener('submit', this.handleSubmit.bind(this));

            window.productForm = this;
        }
    }

    /* 
    Hacky solution to make different notes have different names 
    */
    hackFixNotes() {
        const uploadKitContainers = this.querySelectorAll('.uploadkit .uploadkit-uploader');

        uploadKitContainers.forEach((container, containerIndex) => {
            const noteInputEls = container.querySelectorAll('.uploadkit-text-input');
            const firstInput = container.querySelector('input[type="hidden"]');

            if (!firstInput) {
                return;
            }

            const baseName = firstInput.name.split('[')[1].replace(']', '');

            if (noteInputEls.length > 1) {
                const nameWithoutNumber = baseName.replace(/\s*\d+$/, '');

                noteInputEls.forEach((noteInputEl, index) => {
                    const newName = `properties[Notes ${nameWithoutNumber} ${index + 1}]`;
                    noteInputEl.name = newName;
                });
            } else if (noteInputEls.length === 1) {
                const newName = `properties[Notes ${baseName}]`;
                noteInputEls[0].name = newName;
            }
        });
    }

    hackFixDirectLinkImages() {
        const toDirectUploadKitURL = (u) => {
            try {
                const url = new URL(u);
                const id = url.searchParams.get('id');
                const uu = url.searchParams.get('uu');
                const fi = url.searchParams.get('fi'); // base64 filename

                if (!id || !uu || !fi) {
                    console.warn('Missing required URL parameters for UploadKit URL:', { id, uu, fi });
                    return u; // Return original URL if parameters are missing
                }

                const filename = decodeURIComponent(atob(fi.replace(/-/g, '+').replace(/_/g, '/')));
                return `https://files.getuploadkit.com/${id}/${uu}/${filename}?image`;
            } catch (error) {
                console.error('Error converting to UploadKit URL:', error);
                return u; // Return original URL if conversion fails
            }
        };

        const uploadKitAttributeInputs = this.querySelectorAll('.uploadkit-attribute-container input');

        uploadKitAttributeInputs.forEach((input) => {
            try {
                const sourceInputName = input.name;
                const match = sourceInputName.match(/\[(.*?)\]/);
                if (!match) return;

                const sourcePropertyKey = match ? match[1] : null;
                if (!sourcePropertyKey || !input.value) return;

                const directLinkURL = toDirectUploadKitURL(input.value);

                const directLinkInput = document.createElement('input');
                directLinkInput.type = 'hidden';
                directLinkInput.name = `properties[_${sourcePropertyKey} (direct link)]`;
                directLinkInput.value = directLinkURL;
                input.parentElement.appendChild(directLinkInput);
            } catch (error) {
                console.error('Error applying hack fix:', error);
            }
        });
    }

    hackFixCentimetersProperty() {
        debug.log('hackFixCentimetersProperty');

        // Get the selected variant
        const selectedVariant = this.form.querySelector('.canvas-list__list .selected');
        debug.log('selectedVariant', selectedVariant);

        if (selectedVariant) {
            const cmSize = selectedVariant.getAttribute('data-cm-size');
            debug.log('cmSize', cmSize);

            // Only proceed if we have a CM size (non-inch markets)
            if (cmSize && cmSize.trim() !== '') {
                // Remove any existing Size property first
                const existingSizeProperty = this.form.querySelector('input[name="properties[Size]"]');
                if (existingSizeProperty) {
                    existingSizeProperty.remove();
                    debug.log('Removed existing Size property');
                }

                // Create the centimeters property with "Size" as name and CM size as value
                const cmProperty = document.createElement('input');
                cmProperty.type = 'hidden';
                cmProperty.name = 'properties[Size]';
                cmProperty.value = cmSize;

                // Insert as the FIRST child of the form to ensure it's the first property
                const firstChild = this.form.firstChild;
                if (firstChild) {
                    this.form.insertBefore(cmProperty, firstChild);
                } else {
                    this.form.appendChild(cmProperty);
                }

                debug.log('Created CM property as first element:', {
                    name: cmProperty.name,
                    value: cmProperty.value
                });
            } else {
                debug.log('No CM size found - likely using inches market');
            }
        } else {
            debug.log('No selected variant found');
        }
    }

    createFormData() {
        try {
            // Fix centimeters property FIRST to ensure it's the first line item property
            this.hackFixCentimetersProperty();
            this.hackFixNotes();
            this.hackFixDirectLinkImages();
        } catch (error) {
            console.error('Error applying hack fix:', error);
        }

        const formData = new FormData(this.form);

        const keys = Array.from(formData.keys());

        //remove item[]quantity that don't have an id (multi product forms)
        keys.forEach((key) => {
            console.log('key:', key);
            if (key.includes(']quantity')) {
                const idKey = key.replace('quantity', 'id');
                if (!formData.has(idKey)) {
                    formData.delete(key);
                }
            }
        });

        let sections = 'cart-icon-bubble';
        if (this.cartDrawer) {
            sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }

        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sections);

        return formData;
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
        evt.preventDefault();

        if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

        this.errorMsg = null;
        this.setErrorMsgState();

        // Disable "Add to Cart" button until submission is complete.
        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.classList.add('is-loading');

        const formData = this.createFormData();

        const fetchRequestOpts = {
            method: 'POST',
            headers: {
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
        };

        try {
            const response = await fetch('/cart/add.js', fetchRequestOpts);
            const data = await response.json();

            if (!response.ok) {
                const error = typeof data.description === 'string' ? data.description : data.message;
                this.setErrorMsgState(error);
                throw new Error(response.status);
            }

            console.log('dispacting on:cart:add');

            this.dispatchEvent(
                new CustomEvent('on:cart:add', {
                    bubbles: true,
                    detail: {
                        variantId: data.variant_id,
                        sections: data.sections
                    }
                })
            );

            window.location.href = window.theme.routes.cart;
        } catch (error) {
            console.log(error);

            // Set error message if we have one from the response
            if (this.errorMsg && this.errorMsg.textContent) {
                this.dispatchEvent(
                    new CustomEvent('on:cart:error', {
                        bubbles: true,
                        detail: {
                            error: this.errorMsg.textContent
                        }
                    })
                );
            }
        } finally {
            this.submitBtn.classList.remove('is-loading');
            this.submitBtn.removeAttribute('aria-disabled');
        }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
        this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
        if (!this.errorMsg) return;

        this.errorMsg.classList.toggle('hidden', !error);
        if (error) this.errorMsg.textContent = error;
    }
}

customElements.define('product-form', ProductForm);
